/** Mirrors schema `Mutation.deletePalette(paletteId: ID!): Boolean`. */
export const mutationDeletePalette = `
mutation deletePalette($paletteId: ID!) {
	deletePalette(paletteId: $paletteId)
}
`;
